export default {
    page_title: "Kevi | Informe de Retención",
    title: "Informe de Retención",
    filters: {
        client_segment: "Segmento del cliente",
    },
    common: {
        in: "en",
        between: "entre",
        and: "y",
    },
    stats: {
        average_ticket: "Ticket promedio",
        average_lifetime: "Tiempo de vida promedio",
        average_lifetime_suffix: "Meses",
        average_orders_per_client: "Por cliente en promedio",
        average_orders_suffix: "Pedidos",
        projected_ltv: "LTV Proyectado",
    },
    cohort: {
        action_label: "Acción",
        segment_label: "Segmento",
        select_segment: "Seleccione un segmento",
        view_by: "Ver cohorte por:",
        view_period: "Periodo",
        view_orders: "Número de pedidos",
        interval_label: "Intervalo",
        interval_daily: "Diario",
        interval_weekly: "Semanal",
        interval_monthly: "Mensual",
        interval_yearly: "Anual",
        action_order: "Hizo pedido",
        action_joined_segment: "Entró en el segmento",
        action_left_segment: "Salió del segmento",
        no_data: "No hay datos disponibles para mostrar",
    },
    clients: {
        title: "Clientes",
        cohort: "Cohorte",
        action: "Acción",
        action_order: "compraron",
        action_joined_segment: "entraron en el segmento",
        action_left_segment: "salieron del segmento",
        times_singular: "vez",
        times_plural: "veces",
        times_or_more: "o más",
        years_old_suffix: "años",
        not_informed: "No informada",
        details_button: "Detalles",
    },
    grid: {
        name: "Nombre",
        phone: "Teléfono",
        birthday: "Cumpleaños",
        average_ticket: "Ticket Promedio (R$)",
        total_spent: "R$ Gastado",
        total_orders: "Pedidos Realizados",
        email: "E-mail",
    },
};
